import { render, staticRenderFns } from "./ChatbotPromptList.vue?vue&type=template&id=eef7d1bc"
import script from "./ChatbotPromptList.vue?vue&type=script&lang=js"
export * from "./ChatbotPromptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports